import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import '../../components/MusButton.css';
import gestionStyles from './GestionTorneo.module.css';
import PageHeader from '../../components/page/PageHeader';
import PageBody from '../../components/page/PageBody';
import Confirmation from '../../components/Confirmation';
import {
  MDBIcon,
  MDBTabs,
  MDBTabsItem,
  MDBTabsLink,
  MDBTabsContent,
  MDBTabsPane,
  MDBRow,
  MDBBtn
} from 'mdb-react-ui-kit';
import TorneoStore from '../../stores/TorneoStore';
import ClasificacionPage from './clasificacion/ClasificacionPage';
import RoundPage from './ronda/RondaPage';
import DetallesPartidaPage from './detallesPartida/DetallesPartidaPage';
import MusUtils from '../../utils/Utilities';
import ZerosRow from './zeros/ZerosRow';
import Chronometer from './chronometer/Chronometer';

export default function GestionTorneo() {
  const [torneo, setTorneo] = useState();
  const [roundNum, setRoundNum] = useState();
  const [searchParams, setSearchParams] = useSearchParams();
  const [iconsActive, setIconsActive] = useState('tab1');
  const [isAllowedContinue, setAllowedContinue] = useState(false);
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [hiddeColumns, setHiddeColumns] = useState();
  const [hiddeColumnsBool, setHiddeColumnsBool] = useState(false);
  const [showUndoRoundConfirmation, setShowUndoRoundConfirmation] = useState(false);

  useEffect(() => {
    setHiddeColumns(window.innerWidth < 512 ? 'none':'table-cell');
    setHiddeColumnsBool(hiddeColumns === 'none');
  });

  const navigate = useNavigate();

  useEffect(() => {
    let id = searchParams.get('torneoId');
    let idNum = id ? parseInt(id) : -1;
    let _listadoTorneos = TorneoStore.getInstance().getAllTorneos();
    _listadoTorneos?.forEach((torneoItem) => {
      if (torneoItem.id === idNum) {
        let torneoAux = JSON.parse(JSON.stringify(torneoItem));

        setRoundNum(torneoAux.roundNum > 0 ? torneoAux.roundNum : 1);
        if (torneoAux.roundNum === 0) {
          torneoAux.previousMatches = new Set();
          torneoAux.exemptCounts = new Map();
          torneoAux.clasification = new Map();
        }

        setTorneo({...torneoAux});
        TorneoStore.getInstance().saveTorneo({...torneoAux});
        getMatchesPerPhase();
      }
    });
    window.scrollTo(0, 0);
  },[]);

  useEffect(() => {
    getMatchesPerPhase();
  },[roundNum, torneo]);

  const getMatchesPerPhase = () => {
    if (roundNum && torneo && torneo.championType === 'Liga') {
      if (torneo.roundNum < 1) {
        let torneoAux = {...torneo};
        setTorneo(MusUtils.leagueMatchGenerator(torneoAux, roundNum - 1));
        TorneoStore.getInstance().saveTorneo(torneoAux);
      }
    } else if (roundNum && torneo && torneo.roundNum < 1 && torneo.championType.indexOf('Eliminatoria') !== -1) {
      setRoundNum(torneo.roundNum > 0 ? torneo.roundNum : 1);
      let torneoAux = {...torneo};
      
      // Pre-calcular numZeros rondas para Eliminatoria No Condicionada
      if (torneo.championType === 'EliminatoriaNoCondicionada') {
        const numPreCalculatedRounds = torneo.numZeros;
        // Para Eliminatoria No Condicionada, usar un método especial de pre-cálculo
        // que no requiere exentos en cada ronda
        for (let r = 0; r < torneo.numZeros; r++) {
          // torneoAux = MusUtils.preCalculateEliminatoryRounds(torneoAux, r);
          torneoAux = MusUtils.eliminatoryMatchGenerator(torneoAux, r);
        }
        // Establecer la ronda actual a 1 después de pre-calcular
        torneoAux.roundNum = 1;
      } else {
        // Para Eliminatoria Condicionada, generar solo la primera ronda
        torneoAux = MusUtils.eliminatoryMatchGenerator(torneoAux, roundNum - 1);
      }

      setTorneo(torneoAux);
      TorneoStore.getInstance().saveTorneo(torneoAux);
    }
  }


  const cerrarTorneo = () => {
    navigate('/listadoTorneos')
  }

  const iniciarContinuarRonda = () => {
    let torneoAux = {...torneo};
    if (torneoAux.championType === 'Liga' && torneoAux.roundNum < MusUtils.getLeagueNumRounds(torneoAux)) {
      torneoAux.roundNum = torneoAux.roundNum + 1;
      setRoundNum(torneoAux.roundNum);
      setTorneo({...torneoAux});
      setIconsActive('tab2');
    } else if (torneoAux.championType.indexOf('Eliminatoria') !== -1 && torneoAux.doublets.filter(doublet => doublet.status === "Continua").length > 1) {
      torneoAux.roundNum = torneoAux.roundNum + 1;
      setRoundNum(torneoAux.roundNum);

      // Determine how many rounds were actually pre-calculated (non-empty)
      const preCalculatedCount = torneoAux.roundResults ? torneoAux.roundResults.filter(r => r && r.length > 0).length : 0;

      if (torneoAux.championType === 'EliminatoriaNoCondicionada') {
        // If the next round is within pre-calculated rounds, just advance
        if (torneoAux.roundNum <= preCalculatedCount) {
          setTorneo({...torneoAux});
        } else {
          // Otherwise generate the round dynamically based on current state
          setTorneo(MusUtils.eliminatoryMatchGenerator(torneoAux, torneoAux.roundNum - 1));
        }
      } else {
        // Para Eliminatoria Condicionada, generar dinámicamente
        setTorneo(MusUtils.eliminatoryMatchGenerator(torneoAux, torneoAux.roundNum - 1));
      }
      setIconsActive('tab2');
    } else {
      setIconsActive('tab2');
    }
    setAllowedContinue(false);
  }
    
  const undoRound = () => {
    if (torneo && torneo.roundNum > 1) {
      let torneoAux = { ...torneo };
      // torneoAux.roundResults.pop(); // Eliminar los datos de la ronda actual
      for (let i = torneoAux.roundResults.length - 1; i >= torneoAux.roundNum - 1; i--) {
        torneoAux.roundResults[i] = []; // Limpiar las rondas desde la actual hacia atrás
      }
      torneoAux.roundNum = torneoAux.roundNum - 1; // Volver a la ronda anterior
      
      // Limpiar y reconstruir previousMatches basándose en las rondas restantes
      torneoAux.previousMatches = new Set();
      torneoAux.roundResults.forEach((round, indexRound) => {
        if (round && indexRound < torneoAux.roundNum) { // Solo rondas hasta la nueva roundNum
          round.forEach((match) => {
            if (match && match.ids && match.ids.length === 2) {
              const key = match.ids[0] < match.ids[1] ? `${match.ids[0]}-${match.ids[1]}` : `${match.ids[1]}-${match.ids[0]}`;
              torneoAux.previousMatches.add(key);
            }
          });
        }
      });
      
      TorneoStore.getInstance().saveTorneo(torneoAux); 
      setRoundNum(torneoAux.roundNum);
      setTorneo({...torneoAux});
      setIconsActive('tab2');
      setShowUndoRoundConfirmation(false);
    }
  }

  const cancelUndoRound = () => {
    setShowUndoRoundConfirmation(false);
  }

  const resetRoundResults = () => {
    let torneoAux = MusUtils.resetRoundResults(torneo);
    TorneoStore.getInstance().saveTorneo({...torneoAux});
    setTorneo({...torneoAux})
    setRoundNum(1);
    setShowConfirmation(false);
  }

  const cancelAction = () => {
    setShowConfirmation(false);
  }
  
  const handleIconsClick = (value) => {
    if (value === iconsActive) {
      return;
    }

    setIconsActive(value);
  };

  const onChange = (torneoAux, round, playerNum, mesa, newResult, itemResults) => {
    torneoAux.roundResults[round][mesa].points[playerNum] = parseInt(newResult);
    torneoAux.roundResults[round][mesa].players = itemResults.players;
    torneoAux.roundResults[round][mesa].ids = itemResults.ids;
    setTorneo({...torneoAux});
  }

  return (
    <>
      {torneo && <>
        <PageHeader 
          title={"Torneo"}
          title2={"'" + torneo.name + "'"}
          subTitle1={"Tipo: " + torneo.championType}
          subTitle2={torneo.championType!=="Liga" ? 
            "Num Zeros: " + torneo.numZeros +  " - Num Juegos: " + torneo.numJuegos + " - Ronda Numero: " + torneo.roundNum : 
            "Num Vueltas: " + torneo.numJuegos + " - Ronda Numero: " + torneo.roundNum
          }
          subTitle3={"Consumed: " + localStorage.getItem('mus-torneos').length + " bytes"}
        ></PageHeader>
        <PageBody>
          <Confirmation
                show={showConfirmation}
                setShow={setShowConfirmation}
                title="Confirmacion"
                message="Seguro que desea RESETAR el torneo?"
                cancelAction={cancelAction}
                aceptAction={resetRoundResults}
          ></Confirmation>
          <Confirmation
                show={showUndoRoundConfirmation}
                setShow={setShowUndoRoundConfirmation}
                title="Confirmacion"
                message="Seguro que desea DESHACER la ronda?"
                cancelAction={cancelUndoRound}
                aceptAction={undoRound}
          ></Confirmation>
          <MDBRow>
            <div className='d-flex flex-wrap justify-content-start p-2 col-sm-5 col-12' style={{alignItems: "center"}}>
              {torneo.championType !== 'Liga' ? <ZerosRow torneo={torneo}/> : <></>}
            </div>
            {/* flex-wrap flex-lg-row-reverse */}
            <div className={'d-flex flex-wrap p-2 col-sm-7 col-12 ' + (hiddeColumnsBool ? 'justify-content-around' : 'justify-content-end')}>
              <MDBBtn className='musButton-md m-1' onClick={()=>{cerrarTorneo()}}>
                Cerrar
              </MDBBtn>
              <MDBBtn className='musButton-md m-1' onClick={()=>{iniciarContinuarRonda()}} disabled={!isAllowedContinue}>
                {torneo.roundNum < 1 ? (hiddeColumnsBool ? 'Iniciar' : 'Iniciar Ronda') : (hiddeColumnsBool ? 'Continuar' : 'Continuar Ronda')}
              </MDBBtn>
              <MDBBtn className='musButton-md m-1' color="danger" onClick={()=>setShowUndoRoundConfirmation(true)} disabled={torneo.roundNum < 2 || roundNum !== torneo.roundNum} >
                Deshacer Ronda
              </MDBBtn>
              <MDBBtn className='musButton-md m-1' color="danger" onClick={()=>{setShowConfirmation(true)}}>
                Resetear
              </MDBBtn>
            </div>
          </MDBRow>
          <MDBTabs className={`me-3 ${gestionStyles.musNavLinkDistributed}`}>
            <MDBTabsItem>
              <MDBTabsLink onClick={() => handleIconsClick('tab1')} active={iconsActive === 'tab1'} className={`me-2 ${gestionStyles.musNavLink}`}>
                <MDBIcon fas icon='sitemap'  /> {hiddeColumnsBool ? 'Clasif.' : ' Clasification'}
              </MDBTabsLink>
            </MDBTabsItem>
            <MDBTabsItem>
              <MDBTabsLink onClick={() => handleIconsClick('tab2')} active={iconsActive === 'tab2'} className={`me-2 ${gestionStyles.musNavLink}`}>
                <MDBIcon fas icon='chart-line' /> Ronda
              </MDBTabsLink>
            </MDBTabsItem>
            <MDBTabsItem>
              <MDBTabsLink onClick={() => handleIconsClick('tab3')} active={iconsActive === 'tab3'} className={`me-2 ${gestionStyles.musNavLink}`}>
                <MDBIcon fas icon='info-circle' /> {hiddeColumnsBool ? 'Det.' : ' Detalles'}
              </MDBTabsLink>
            </MDBTabsItem>
            <MDBTabsItem>
              <MDBTabsLink onClick={() => handleIconsClick('tab4')} active={iconsActive === 'tab4'} className={`me-2 ${gestionStyles.musNavLink}`}>
                <MDBIcon fas icon='clock' /> Cronómetro
              </MDBTabsLink>
            </MDBTabsItem>
          </MDBTabs>

          {torneo && <MDBTabsContent>
            <MDBTabsPane show={iconsActive === 'tab1'}><ClasificacionPage torneoEnCurso={torneo} onChange={onChange}></ClasificacionPage></MDBTabsPane>
            <MDBTabsPane show={iconsActive === 'tab2'}><RoundPage torneoEnCurso={torneo} onChange={onChange} setAllowedContinue={setAllowedContinue} onRoundNumChange={setRoundNum}></RoundPage></MDBTabsPane>
            <MDBTabsPane show={iconsActive === 'tab3'}><DetallesPartidaPage torneoEnCurso={torneo} onChange={onChange} setAllowedContinue={setAllowedContinue}></DetallesPartidaPage></MDBTabsPane>
            <MDBTabsPane show={iconsActive === 'tab4'}><Chronometer startTime={torneo.startTime} status={torneo.status}></Chronometer></MDBTabsPane>
          </MDBTabsContent>}
        </PageBody>
      </>}
    </>
  );
}
